import { useCallback } from 'react'
import {
  OpportunityAppDataInput,
  SoldServiceAppDataModel,
} from '@user/store/opportunity'
import { parseFieldValue } from '@user/components/Opportunities/SoldServicesDrawer/SoldServicesContent/AdditionalInfo/functions'
import { BulkCloseWinFormModel } from '../typings'

export function useOnSubmit(
  entityIds: number[],
  appData: SoldServiceAppDataModel[],
  onBulkCloseWin: (CloseWinOpportunityInput) => Promise<void>,
) {
  return useCallback(
    async (formModel: BulkCloseWinFormModel) => {
      const { customFields } = formModel

      const fieldNames = customFields ? Object.keys(customFields) : []

      const input = fieldNames.reduce<OpportunityAppDataInput[]>(
        (acc, fieldName) => {
          const model = appData.find((x) => x.id === fieldName)
          if (!model) return acc

          const { id, caption, type } = model

          const rawValue = customFields[fieldName]

          const { value, valueId } = parseFieldValue(model, rawValue)

          const input: OpportunityAppDataInput = {
            value,
            valueId,
            key: id,
            caption,
            valueType: type,
          }

          return [...acc, input]
        },
        [],
      )

      await onBulkCloseWin({
        Ids: entityIds,
        appData: input,
        salesNote: formModel.salesNote,
      })
    },
    [appData, entityIds, onBulkCloseWin],
  )
}
